import { identity } from 'lodash';
import React, { useEffect, useRef } from 'react';
import urlparam from 'urlparam';
import { TIME_FORMAT_USER } from '../../../../../../../../data/constants/datetime';
import { isUserMeetingCancelled } from '../../../../../../../../data/filters/meetings/isUserMeetingCancelled';
import { isUserMeetingConfirmed } from '../../../../../../../../data/filters/meetings/isUserMeetingConfirmed';
import { isUserMeetingPending } from '../../../../../../../../data/filters/meetings/isUserMeetingPending';
import { useI18n } from '../../../../../../../../data/hooks/i18nHooks';
import { useMeetingInvites } from '../../../../../../../../data/hooks/meeting/useMeetingInvites/useMeetingInvites';
import { useMyUserId } from '../../../../../../../../data/hooks/sessionHooks';
import { eventMomentFactory } from '../../../../../../../../data/misc/eventMomentFactory';
import getUserFromMeetingInvite from '../../../../../../../../misc/getUserFromMeetingInvite';
import UserAvatar from '../../../../../../../elements/icons/UserAvatar/UserAvatar';
import Link from '../../../../../../../elements/Link';
import Location from '../../../../../../../elements/Location';
import MeetingStateDescription from '../../../../../../../elements/MeetingStateController/CurrentMeetingState/MeetingStateDescription';
import MeetingStateIcon from '../../../../../../../elements/MeetingStateIcon';
import UserName from '../../../../../../../elements/UserName/UserName';
import styles from './ListItemMeeting.module.scss';
import MeetingMotif from './MeetingMotif';

function ListItemMeeting(props) {
    const { tagName: Tag = 'li', event, meeting } = props,
        start = eventMomentFactory(event, meeting.start_local).format(TIME_FORMAT_USER),
        selfUserId = useMyUserId(),
        i18n = useI18n(),
    // peers = useMeetingPeers(event.id, meeting.id),
        invites = useMeetingInvites(event.id, meeting.id, { includeInitiator: true }),
        peers = invites.map((invite) => getUserFromMeetingInvite(invite, i18n)),
        firstOther = peers[0],
        focusMeeting = urlparam('meeting'),
        ref = useRef(),
        href = ['.', meeting.id].join('/'),
        confirmed = isUserMeetingConfirmed(selfUserId, meeting),
        pending = isUserMeetingPending(selfUserId, meeting),
        cancelled = isUserMeetingCancelled(selfUserId, meeting),
        isInitiator = meeting.initiator.id == selfUserId;

    useEffect(() => {
        if (!focusMeeting) return;
        if (meeting.id != focusMeeting) return;
        if (!ref.current?.scrollIntoView) return;
        ref.current.scrollIntoView({ behavior: 'smooth' });
    }, [focusMeeting]);

    if (!firstOther) return null;

    return (
        <Tag
            ref={ref}
            className={[styles.ListItemMeeting, confirmed ? styles.confirmed : '', pending ? styles.pending : '', cancelled ? styles.cancelled : '', isInitiator ? styles.initiator : ''].join(' ')}>
            <Link href={href}>
                <div className={styles.time}>{start}</div>
                {confirmed ? <Location className={styles.location}>{meeting.location.name}</Location> : <MeetingStateDescription className={styles.state} meeting={meeting} />}
                <MeetingStateIcon className={[styles.stateIcon, meeting._myInvite ? '' : styles.initiator].join(' ')} event={event} meeting={meeting} invite={meeting._myInvite} allowStateChange />

                <UserAvatar className={styles.avatar} user={firstOther} onClick={identity} />
                <div className={styles.user} href={href}>
                    <div className={[styles.name, 'text', 'name'].join(' ')}>
                        <UserName user={firstOther} />
                    </div>
                    <div className="text position">{firstOther.position}</div>
                    <div className="text company">{firstOther.company}</div>
                    {peers.length > 1 ? <div className={styles.andOthers}>{i18n['meeting.and.count'].replace('{0}', peers.length - 1)}</div> : null}
                    <MeetingMotif className={styles.motif} meeting={meeting} />
                </div>
            </Link>
        </Tag>
    );
}

export default ListItemMeeting;
